import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import TaskModalDialog from 'pages/allTasks/TaskModal/TaskModalDialog';
import { useExchangeTaskModal } from './useExchangeTaskModal';

interface ExchangeTaskModalProps {
  campaignId: string;
  isOpen: boolean;
  onClose: () => void;
  tasks: AutopilotTaskDto[];
  title: string;
}

const ExchangeTaskModal = ({
  campaignId,
  isOpen,
  onClose,
  tasks,
  title,
}: ExchangeTaskModalProps) => {
  const { campaign, contentConfig } = useExchangeTaskModal({
    campaignId,
    isOpen,
    tasks,
  });

  if (!campaign) return null;

  return (
    <TaskModalDialog
      title={title}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      campaign={campaign}
      contentConfig={contentConfig}
    />
  );
};

export default ExchangeTaskModal;
